"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTrack = exports.Track = void 0;
Object.defineProperty(exports, "mixpanel", {
  enumerable: true,
  get: function () {
    return _mixpanelBrowser.default;
  }
});
exports.useTracking = exports.track = exports.optInTrack = void 0;
var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const track = (event_name, properties) => {
  if (!_mixpanelBrowser.default.config) return;
  _mixpanelBrowser.default.track(event_name, properties);
};
exports.track = track;
const getToken = (siteId, env) => {
  switch (env) {
    case 'preproduction':
    case 'preprodaws':
      {
        switch (siteId) {
          case 66:
            return '2b4259a037aec20b32a4ae7cb1abebc7';
          case 69:
            return '95ea70a0118af0d80f4d0ed9ca024738';
          default:
            return 'eae7ed6b6420b0befde82c2e721ae890';
        }
      }
    case 'production':
    case 'prod':
      switch (siteId) {
        case 1:
          return 'a3cb8bb25549b48e7409f1211fc04976';
        // france
        case 2:
          return '9b6b75a37c6eff06bf14132f67d55e37';
        // germany
        case 3:
          return '2cf592140dba3dc4402b360233a6dd45';
        // spain
        case 4:
          return 'b1d06f62ef92319ca25f11d487b35d8b';
        // italy
        case 7:
          return 'e1fcf2661096212f64500ac5c70b6956';
        // austria
        case 66:
          return 'e39a3b46dfc09817178d1c18a2bceda5';
        // spain privalia
        case 69:
          return '1cc66c7dc984f3f7830675b6c8dd0e1f';
        // italy privalia
        case 70:
          return '69a6e42ce2809abc255bb9ae23faeb4b';
        case 71:
          return '974bdc6ae4584aa38454bab8fa711507';
        case 73:
          return '29c32372870a21fdfd1d5734f4fafabb';
        case 76:
          return 'adc328f10cd88ca5604020c26154816b';
        default:
          return undefined;
      }
    default:
      return undefined;
  }
};
const getConfig = () => ({
  track_pageview: false,
  persistence: 'localStorage',
  opt_out_tracking_by_default: true,
  api_host: '/tr'
});
const initTrack = (siteId, env, optedIn = false) => {
  _mixpanelBrowser.default.init(getToken(siteId, env), getConfig());
  if (_mixpanelBrowser.default.config && !optedIn) _mixpanelBrowser.default.opt_out_tracking();
};
exports.initTrack = initTrack;
const optInTrack = () => {
  if (!_mixpanelBrowser.default.config || _mixpanelBrowser.default.has_opted_in_tracking()) return;
  _mixpanelBrowser.default.opt_in_tracking();
};

/** @deprecated */
exports.optInTrack = optInTrack;
const Context = /*#__PURE__*/(0, _react.createContext)();
/** @deprecated */
const useTracking = () => (0, _react.useContext)(Context);
/** @deprecated */
exports.useTracking = useTracking;
const Track = ({
  track,
  children
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Context.Provider, {
  value: {
    track
  },
  children: children
});
exports.Track = Track;